module.exports = __webpack_public_path__ + "img/newsImg2.54db9055.png";